import React from 'react'

const AuditTrail = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Audit Trail</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Staff & Roles</li>
            <li className="breadcrumb-item active">Audit Trail</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-shield-check me-2"></i>
                  Audit Trail
                </h5>
                <p>View comprehensive audit logs of all system activities. Track user actions, changes, and system events for security and compliance.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default AuditTrail

